import { useEffect, useState } from "react";
import { Navbar } from "@/components/Navbar";
import { HeroSection } from "@/components/HeroSection";
import { AboutSection } from "@/components/AboutSection";
import { FeaturesSection } from "@/components/FeaturesSection";
import { ServicesSection } from "@/components/ServicesSection";
import { BusGallerySection } from "@/components/BusGallerySection";
import { BusAmenitiesSection } from "@/components/BusAmenitiesSection";
import { ThirdPartyPartners } from "@/components/ThirdPartyPartners";
import { ContactSection } from "@/components/ContactSection";
import { Footer } from "@/components/Footer";
import { WhatsAppChatbotCard } from "@/components/WhatsAppChatbotCard";
import { SkeletonHero, SkeletonCard } from "@/components/ui/skeleton-card";
import { siteConfig } from "@/config/siteConfig";

const Index = () => {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Simulate initial page load
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  // Update document title
  useEffect(() => {
    document.title = `${siteConfig.companyName} - ${siteConfig.tagline}`;
  }, []);

  if (isLoading) {
    return (
      <div className="min-h-screen bg-background">
        {/* Loading skeleton */}
        <div className="fixed top-0 left-0 right-0 h-16 glass z-50" />
        <SkeletonHero />
        <div className="container mx-auto px-4 py-16">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {[1, 2, 3].map((i) => (
              <SkeletonCard key={i} />
            ))}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-background overflow-x-hidden">
      <Navbar />
      <main>
        <HeroSection />
        <ServicesSection />
        <AboutSection />
        <FeaturesSection />
        <BusGallerySection />
        <BusAmenitiesSection />
        
        {/* WhatsApp Chatbot Card - only show if enabled */}
        {siteConfig.whatsappChatbot.enabled && (
          <section className="section-padding bg-secondary/10">
            <div className="container mx-auto px-4">
              <div className="max-w-4xl mx-auto">
                <WhatsAppChatbotCard />
              </div>
            </div>
          </section>
        )}
        
        <ThirdPartyPartners />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
};

export default Index;
